// extracted by mini-css-extract-plugin
export var childrenContainer = "_84-0";